import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';

const DeadlineContext = createContext();

export const DeadlineProvider = ({ children }) => {
    const eventid = localStorage.getItem('eventid'); // Get the eventid from localStorage
    const [offButton, setOffButton] = useState(false);
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        event_title: "",
        conference_website: "",
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        sponser_logo_size: "",
        color_code_four: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        workshopBannerImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        online_status: "",
        bank_status: "",
        cash_status: "",
        free_status: "",
        uae_darham: "",
        saudi_riyal: "",
        usa_dollor: "",
        default_currency: "",

        exhibition_module: "",
        workshop_module: "",
        abstract_module: "",
        eventLogo: "",
        abstractEndDate: "",
        abstractEndTime: "",
        abstract_deadline_status: "",
        error_list: [],
    });

    const getAbstractEndDate = abstractHomeSetup.abstractEndDate || "";
    const getAbstractEndTime = abstractHomeSetup.abstractEndTime || "";
    const getAbstractDeadLineStatus = abstractHomeSetup.abstract_deadline_status;

    const [refresh, setRefresh] = useState(0);
    const [runTheCodeData, setData] = useState(null);
    const [runIntervalTimeCodeRun, setRunIntervalTimeCodeRun] = useState();


    const triggerRefresh = () => {
        const data = {
            eventid: eventid,
            runTheCodeData,
        };

        // Make the POST request first
        axios.post('api/change-status-for-run-function', data)
            .then(res => {
                if (res.status === 200) {
                    swal('Success', res.data.message, 'success'); // Show success message

                    // After POST request is successful, trigger a re-render by updating `refresh` state
                    console.log("Context Button clicked, refreshing...");
                    console.log("runIntervalTimeCodeRun component", runIntervalTimeCodeRun);

                    // Increment the refresh state to trigger the `useEffect` hook
                    setRefresh(prev => prev + 1);
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    };



    const data = { newValue: runTheCodeData };
    useEffect(() => {
        if (!eventid) return; // Skip if eventid is not available

        axios.get(`api/check-status-for-run-function?id=${eventid}`, { params: data }) // Use params to send data
            .then(res => {
                if (res.status === 200) {
                    const runTheCode = res.data.isCoderun;
                    setData(runTheCode);
                    setRunIntervalTimeCodeRun(runTheCode);
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });

    }, [refresh, runIntervalTimeCodeRun]);




    // Effect to check if data is in localStorage and update context
    useEffect(() => {
        if (!eventid) return; // Skip if eventid is not available

        // Check if the data for this eventid is already in localStorage
        const cachedData = localStorage.getItem(`homeSetupData-${eventid}`);
        if (cachedData) {
            setAbstractHomeSetup(JSON.parse(cachedData)); // Use cached data
        } else {
            // Fetch data if not available in localStorage
            const fetchHomeSetupData = async () => {
                try {
                    const res = await axios.get(`api/add-home-setup-index?id=${eventid}`);
                    if (res.status === 200) {
                        setAbstractHomeSetup(res.data.HomePageSetup);
                     
                        // Save fetched data to localStorage for future use
                        localStorage.setItem(`homeSetupData-${eventid}`, JSON.stringify(res.data.HomePageSetup));
                    }
                } catch (error) {
                    console.error('Error fetching home setup data:', error);
                }
            };

            fetchHomeSetupData();
        }
    }, [eventid]); // Only run once when eventid is available





    const [reload, setReload] = useState(false);
    // This effect will run once on mount and trigger a reload after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setReload(true); // Trigger reload after 2 seconds
        }, 2000);
        // Clean up the timer
        return () => clearTimeout(timer);
    }, []);
    // Effect to handle the reload state change (this will trigger a re-render)
    useEffect(() => {
        if (reload) {
            // You can reset the reload state to false to avoid it from repeating again
            setReload(false);
        }
    }, [reload]);


    // Effect to handle the deadline check and reload data if API data changes
    useEffect(() => {
        if (!eventid) return; // Skip if eventid is not available

        const checkDeadline = async () => {
            if (offButton || getAbstractDeadLineStatus === 0) return; // Skip if already disabled

            const currentTime = new Date().getTime();
            const deadlineString = `${getAbstractEndDate}T${getAbstractEndTime.substring(0, 8)}+03:00`;

            try {
                const deadlineTime = new Date(deadlineString).getTime();

                if (currentTime >= deadlineTime) {
                    if (!offButton) {
                        setOffButton(true); // Disable the button
                    }

                    if (getAbstractDeadLineStatus === 1) {
                        const data = {
                            getAbstractDeadLineStatus: 0,
                            eventid,
                        };

                        await axios.get('/sanctum/csrf-cookie');

                        const res = await axios.post(`/api/abstract-deadline-closed?id=${eventid}`, data);

                        if (res.data.status === 200) {
                            swal('Success', res.data.message, 'success');

                            // Fetch updated data after the deadline status update
                            const homeSetupRes = await axios.get(`api/add-home-setup-index?id=${eventid}`);

                            if (homeSetupRes.status === 200) {
                                const getHomePageData = homeSetupRes.data.HomePageSetup;
                                setAbstractHomeSetup(getHomePageData); // Set the updated data
                                localStorage.setItem(`homeSetupData-${eventid}`, JSON.stringify(getHomePageData)); // Cache updated data
                            }
                        }
                    }
                }
            } catch (error) {
                console.error('Error checking deadline or updating status:', error);
            }
        };

        checkDeadline();



        // const interval = setInterval(() => {
        //     // Fetch updated data from the API every 5 seconds and check for changes
        //     const fetchHomeSetupData = async () => {
        //         try {
        //             const res = await axios.get(`api/add-home-setup-index?id=${eventid}`);
        //             if (res.status === 200) {
        //                 const newData = res.data.HomePageSetup;
        //                 const cachedData = localStorage.getItem(`homeSetupData-${eventid}`);
        //                 const cachedDataParsed = cachedData ? JSON.parse(cachedData) : null;

        //                 // Only update if the new data is different from the cached data
        //                 if (JSON.stringify(newData) !== JSON.stringify(cachedDataParsed)) {
        //                     setAbstractHomeSetup(newData); // Update state with new data
        //                     localStorage.setItem(`homeSetupData-${eventid}`, JSON.stringify(newData)); // Replace the cached data
        //                 }
        //             }
        //         } catch (error) {
        //             console.error('Error fetching home setup data:', error);
        //         }
        //     };

        //     fetchHomeSetupData();
        // }, 10000); // Check every 1 mints for changes

        // return () => clearInterval(interval); // Cleanup on unmount


    }, [getAbstractEndDate, getAbstractEndTime, getAbstractDeadLineStatus, eventid, offButton,]);


    // useEffect(() => {
    //     if (!eventid) return;

    //     let eventSource = new EventSource(`https://dev.cloudregis.com/v4.1/laravel/public/api/sse-home-setup?id=${eventid}`);
    //     let retryInterval = 5000; // Start with 5 seconds

    //     eventSource.onopen = () => {
    //         console.log('SSE connection established');
    //     };

    //     eventSource.onmessage = (event) => {
    //         const newData = JSON.parse(event.data);

    //         const cachedData = localStorage.getItem(`homeSetupData-${eventid}`);
    //         const cachedDataParsed = cachedData ? JSON.parse(cachedData) : null;

    //         // Only update if the new data is different from the cached data
    //         if (JSON.stringify(newData) !== JSON.stringify(cachedDataParsed)) {
    //             setAbstractHomeSetup(newData); // Update state with new data
    //             localStorage.setItem(`homeSetupData-${eventid}`, JSON.stringify(newData)); // Replace the cached data
    //         }

    //         retryInterval = 5000; // Reset retry interval on successful response
    //     };

    //     eventSource.onerror = (error) => {
    //         console.error("SSE Error:", error);
    //         eventSource.close();

    //         // Implement exponential backoff (max 1 minute)
    //         setTimeout(() => {
    //             console.log(`Reconnecting to SSE in ${retryInterval / 1000} seconds...`);
    //             eventSource = new EventSource(`https://dev.cloudregis.com/v4.1/laravel/public/api/sse-home-setup?id=${eventid}`);
    //             retryInterval = Math.min(retryInterval * 2, 60000); // Increase retry interval
    //         }, retryInterval);
    //     };

    //     return () => {
    //         eventSource.close();
    //     };
    // }, [eventid]);


    useEffect(() => {
         if (!eventid) return;
        let interval; // Declare interval outside to track and clear it

        const startFetching = () => {
            if (runIntervalTimeCodeRun === 1 && !interval) { // Prevent multiple intervals
                interval = setInterval(async () => {
                    try {
                        const res = await axios.get(`api/add-home-setup-index?id=${eventid}`);
                        if (res.status === 200) {
                            const newData = res.data.HomePageSetup;
                            const cachedData = localStorage.getItem(`homeSetupData-${eventid}`);
                            const cachedDataParsed = cachedData ? JSON.parse(cachedData) : null;

                            if (JSON.stringify(newData) !== JSON.stringify(cachedDataParsed)) {
                                setAbstractHomeSetup(newData);
                                localStorage.setItem(`homeSetupData-${eventid}`, JSON.stringify(newData));
                            }
                        }
                    } catch (error) {
                        console.error('Error fetching home setup data:', error);
                    }
                }, 10000);
            } else {
                console.log("runIntervalTimeCodeRun is 0", runIntervalTimeCodeRun);
            }
        };

        const stopFetching = () => {
            if (interval) {
                clearInterval(interval);
                interval = null; // Reset interval
            }
        };

        // Only start fetching if `runIntervalTimeCodeRun` is 1
        if (runIntervalTimeCodeRun === 1) {
            startFetching();
        } else {
            stopFetching();
        }

        // Cleanup function to clear the interval
        return () => stopFetching();

    }, [runIntervalTimeCodeRun, eventid]);




    return (
        <DeadlineContext.Provider value={{ offButton, abstractHomeSetup, getAbstractDeadLineStatus, refresh, triggerRefresh, runTheCodeData }}>
            {children}
        </DeadlineContext.Provider>
    );
};

export const useDeadline = () => React.useContext(DeadlineContext);
